import { createApp } from 'vue';
import App from './App.vue';
import router, { initRoutes } from './router';
import store from './store';

async function setupApp() {
  const app = createApp(App);

  // Edge 浏览器 replaceState 补丁
  const isEdge = /Edg\/\d+/.test(navigator.userAgent);
  if (isEdge) {
    const originalReplaceState = window.history.replaceState;
    const isProblematicReplaceState = (state: any, title: unknown, url?: unknown): boolean => {
      if (typeof title !== 'string' || title !== '') return false;
      if (url !== undefined) return false;
      if (!state || typeof state !== 'object') return false;
      const hasRouterStateProps =
        'back' in state && 'current' in state && 'position' in state && 'scroll' in state;
      return hasRouterStateProps;
    };
    window.history.replaceState = function (state, title, url) {
      if (isProblematicReplaceState(state, title, url)) {
        console.log('Edge 拦截可能异常的 replaceState');
        return;
      }
      return originalReplaceState.call(this, state, title, url);
    };
  }

  try {
    initRoutes();
    app.use(store);
    app.use(router);
    app.mount('#app');
  } catch (error) {
    console.error('应用初始化失败', error);
  }
}

setupApp();